enum DoctorList_UrlParameters {
    "adminCenterTarget" = "target",
    "action"="action",
    "item" = "evt",
    "dateStart" = "ds",
    "dateEnd" = "dE",
    "intervalType" = "vm",
    //"intervalSteps" = "step"


}
(globalThis as any).DoctorList_UrlParameters = DoctorList_UrlParameters; // (mds A11) seed runtime value for cross-file bare refs

declare namespace DoctorList {
    interface DoctorData {
        id?: string;
        is_active?: boolean;
        WebUserId: string;
        username: string;
        email: string;
        password?: string;
        confirmPassword?: string;
        salutation: string;
        title: string;
        first_name: string;
        last_name: string;
        birthdate: string;
        address: string;
        postal_code: string;
        city: string;
        phone_mobile: string;
        phone_landline: string;
        ban: string;
        note: string;
        monthlyInfomail: boolean;
        is_marked_for_deleting: boolean;
        absence_count: number;
        approbation: string | Object;
    }
}
